import { getPublicConfig } from "@/shared/config/config"
import type { HttpClient } from "@/shared/types/HttpClient"
import type { CreateAccessRequestResponse } from "../types/CreateAccessRequestResponse"

const { cmApiBaseUrl } = getPublicConfig()
const accessRequestApiBaseUrl = `${cmApiBaseUrl}/access_request`

export const createAccessRequestApi = (client: HttpClient) => ({
  createAccessRequest: async (): Promise<CreateAccessRequestResponse> =>
    client.post<CreateAccessRequestResponse>(`${accessRequestApiBaseUrl}`, {})
})
